export type FaceMeasurements = {
  faceWidth: string
  farPD: {
    leftPD: string
    pd: string
    rightPD: string
  }
  nearPD: {
    leftPD: string
    pd: string
    rightPD: string
  }
  segmentHeight: {
    leftSH: string
    rightSH: string
  }
}

export const getShResult = (l: number, r: number) => ({
  faceMeasurements: {
    farPD: {
      pd: '',
      leftPD: '',
      rightPD: '',
    },
    nearPD: {
      pd: '',
      leftPD: '',
      rightPD: '',
    },
    faceWidth: '',
    segmentHeight: {
      leftSH: `${l} mm`,
      rightSH: `${r} mm`,
    },
  } satisfies FaceMeasurements,
  faceShape: 'None',
})

export const getPdResult = (l: number, r: number) => ({
  faceMeasurements: {
    farPD: {
      pd: '',
      leftPD: `${l} mm`,
      rightPD: `${r} mm`,
    },
    nearPD: {
      pd: '',
      leftPD: `${l} mm`,
      rightPD: `${r} mm`,
    },
    faceWidth: '',
    segmentHeight: {
      leftSH: '',
      rightSH: '',
    },
  },
  faceShape: 'None',
})
